import React from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { PageTitle } from "../../components/Common/PageTitle";
import { DownloadActivityLogs } from "../../components/DataDownloadComponents/DownloadActivityLogs";
import { DownloadLocationStats } from "../../components/DataDownloadComponents/DownloadLocationStats";
import { DownloadMetrics } from "../../components/DataDownloadComponents/DownloadMetrics";
import { LocationSelect } from "../../components/DataDownloadComponents/LocationSelect";
import { useLocationSelect } from "../../components/DataDownloadComponents/LocationSelect/hooks";
import { useValidateOrganization } from "../../hooks/validateUserOrganization";

import "./styles.scss";

type IDataDownloadPageProps = RouteComponentProps<any>;

const DataDownloadPage: React.FunctionComponent<IDataDownloadPageProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`dataDownloadPage.${key}`);

  const matchOrganizationId = props.match.params.organizationId;

  useValidateOrganization({
    matchOrganizationId,
    redirectUrlFormat: (orgId) => `/data/organization/${orgId}`,
  });

  const locationSelect = useLocationSelect(matchOrganizationId);

  return (
    <div className="right-content data-download-page">
      <div className="top-title-bar flex-grid">
        <PageTitle text={t("data_download")} />
      </div>
      <LocationSelect locationSelect={locationSelect} />
      <DownloadMetrics
        locations={locationSelect.selectedLocations}
        organizationId={matchOrganizationId}
      />
      <DownloadActivityLogs
        locations={locationSelect.selectedLocations}
        organizationId={matchOrganizationId}
      />
      <DownloadLocationStats
        locations={locationSelect.selectedLocations}
        organizationId={matchOrganizationId}
      />
    </div>
  );
};

export default withRouter(DataDownloadPage);
